import styled from 'styled-components';

export const BackArrowIcon = styled.img`
  width: 3.733vw;
  height: 3.733vw;
  position: absolute;
  left: 4.5vw;
  top: 3.5vw;
  padding: 0 3vw 0 3vw;
`;
